import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { CONSTANTS } from '@core/constants';
import { ApplicationEvent, LoadingEvent } from '@core/interfaces';
import { EventService } from '@core/services';

import { endpoints } from '@environment';

import { FileDownloadRequest, FileDownloadResponseBody, FileUploadRequest, FileUploadResponseBody } from '#types/file';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  event$ = new Subject<ApplicationEvent>();
  loading$ = new Subject<LoadingEvent>();

  fileUploaded$ = new Subject<void>();

  constructor(private http: HttpClient, private eventService: EventService) {}

  upload(payload: FileUploadRequest) {
    return this.http.post(endpoints.file.upload, payload, { withCredentials: true }).pipe(
      this.eventService.indicate(CONSTANTS.FILE_UPLOAD),
      map((response: FileUploadResponseBody) => response)
    );
  }

  download(payload: FileDownloadRequest) {
    return this.http.post(endpoints.file.download, payload, { withCredentials: true, responseType: 'blob' }).pipe(
      this.eventService.indicate(CONSTANTS.FILE_DOWNLOAD),
      map((response: FileDownloadResponseBody) => response)
    );
  }

  clientDownload(filename: string, mimeType: string, data: Blob) {
    const blob = new Blob([data], {
      type: mimeType,
    });

    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;

    a.download = filename;

    document.body.appendChild(a);
    a.style.display = 'none';
    a.click();
    a.remove();

    setTimeout(() => {
      window.URL.revokeObjectURL(url);
    }, 1000);
  }
}
